import { render, staticRenderFns } from "./UserFilter.vue?vue&type=template&id=2195a3d8&"
import script from "./UserFilter.vue?vue&type=script&lang=js&"
export * from "./UserFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/paywall/users/UserFilter.vue
// module id = 1430
// module chunks = 0